import type { PropsWithChildren, TimeHTMLAttributes } from 'react';

type BlogFeaturedDateProps = PropsWithChildren<TimeHTMLAttributes<HTMLTimeElement>>

export const BlogFeaturedDate = ( { children, ...timeAttributes }: BlogFeaturedDateProps ) => {

  return (
    <time
      className={ 'text-[10px] font-onest text-[#ABB0C7] group-data-[variant="light"]:text-black' }
      { ...timeAttributes }>
      { children }
    </time>
  )
}
BlogFeaturedDate.displayName = 'BlogFeaturedDate';
